import { templateId } from 'utils/app';
import { replaceNewlineWithBreak } from 'utils/helpers';
import { sdk } from 'utils/query';

export const sendPrescriptionMail = async (
  recipient: string,
  prescriptionReference: string,
  base64Prescription: string,
  emailSubject: string,
  emailBody: string,
) => {
  return sdk.mails.send({
    recipients: {
      to: [recipient],
    },
    templateId,
    content: {
      message: replaceNewlineWithBreak(emailBody),
      subject: emailSubject,
    },
    attachments: [
      {
        name: prescriptionReference,
        content: base64Prescription,
        type: 'application/pdf',
      },
    ],
  });
};
